<template>
  <va-create-layout>
    <users-form :title="title" :item="item" :parentId="parentId"></users-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
